import { Button, Tooltip, Typography } from "@mui/material";
import CustomDialog from "../../../../commons/dialog/customDialog";
import CircularLoading from "../../../../commons/loadingData/circularLoading";
import { StyledAccidentsFecadeAndOpen } from "../../../../styled/accident";
import FacadeAccidentCards from "./facadeAccidentCards";
import OpenAccidentCards from "./openAccidentCards";

const AccidentsFacadeAndOpen = ({
  open,
  handleClose,
  openAccidents,
  facadeAccidents,
  handleView,
  handleAdd,
  handleEdit,
  loading,
}) => {
  return (
    <CustomDialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
    >
      <StyledAccidentsFecadeAndOpen.TitleContainer>
        <StyledAccidentsFecadeAndOpen.Title variant="h6">
          {openAccidents.length !== 0
            ? openAccidents[0].trabajador
            : facadeAccidents.length !== 0
              ? `${facadeAccidents[0].apellidoTrabajador || ""}, ${facadeAccidents[0].nombreTrabajador || ""
              }`
              : ""}
        </StyledAccidentsFecadeAndOpen.Title>
        <StyledAccidentsFecadeAndOpen.Title variant="h6">
          {openAccidents.length !== 0 ? openAccidents[0].art : ""}
        </StyledAccidentsFecadeAndOpen.Title>
        <Tooltip title="Cerrar">
          <StyledAccidentsFecadeAndOpen.CloseIcon onClick={handleClose} />
        </Tooltip>
      </StyledAccidentsFecadeAndOpen.TitleContainer>
      <StyledAccidentsFecadeAndOpen.CardContainer>
        {loading ? (
          <StyledAccidentsFecadeAndOpen.CircularLoadingContainer>
            <CircularLoading />
          </StyledAccidentsFecadeAndOpen.CircularLoadingContainer>
        ) : openAccidents.length === 0 && facadeAccidents.length === 0 ? (
          <StyledAccidentsFecadeAndOpen.EmptyState>
            <Typography variant="h6">
              No se encontraron siniestros para los datos ingresados
            </Typography>
            <StyledAccidentsFecadeAndOpen.ArtText variant="subtitle1">
              Consulte con la ART
            </StyledAccidentsFecadeAndOpen.ArtText>
            <Button variant="contained" color="primary" onClick={handleClose}>
              Cerrar
            </Button>
          </StyledAccidentsFecadeAndOpen.EmptyState>
        ) : (
          <div>
            <FacadeAccidentCards
              accidents={facadeAccidents}
              handleAdd={handleAdd}
              handleEdit={handleEdit}
            />
            <OpenAccidentCards
              accidents={openAccidents}
              handleView={handleView}
            />
          </div>
        )}
      </StyledAccidentsFecadeAndOpen.CardContainer>
    </CustomDialog>
  );
};

export default AccidentsFacadeAndOpen;
